import cfg from './configuration/PropertiesConfiguration'
export class PTSessionsService {
  constructor (axios) {
    this.axios = axios
  }

  getPTSessionsHistory () {
    return this.axios.get(cfg.ptSessionsHistory, {useCache: true})
  }

  validateDateRange (fromDate, toDate) {
    console.log(fromDate)
    console.log(toDate)
    return this.axios.get(cfg.ptSessionsHistory, {
      params: {
        fromDate: fromDate,
        toDate: toDate
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/PTSessionsService.js